import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import ImageSwiper from './ImageSwiper'

const ProductImages = ({ images, variantsNum, id }) => {
  const pc = 'ou_product-card'

  return (
    <div
      id={`ou_product_card_images_${id}`}
      className={cx(`${pc}__images-block`, variantsNum > 1 && `${pc}__images-block--${variantsNum}`)}
    >
      <div className={`${pc}__image-before`} />
      <ImageSwiper images={images} />
      <div className={`${pc}__image-after`} />
    </div>
  )
}

ProductImages.propTypes = {
  variantsNum: PropTypes.number,
  images: PropTypes.array,
  id: PropTypes.number
}

export default ProductImages



// WEBPACK FOOTER //
// ./src/templates/outSide/components/products/ProductImages.js